import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconThumbsUp12Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.511 4.995A1.5 1.5 0 0 0 1 6.495v3.02a1.5 1.5 0 0 0 1.5 1.5H3V4.998zM4 4.335v6.68h4.498a1.5 1.5 0 0 0 1.386-.925l1.256-3.032a1.5 1.5 0 0 0-1.385-2.075H8V2.001C8 1.04 6.776.63 6.2 1.4z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp12Filled);
